import React, { MouseEvent, useState } from 'react';
import Toolbar from '@mui/material/Toolbar';
import HeaderBar from './HeaderBar';
import ServicesPopover from './ServicesPopover';


const Header: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const open = Boolean(anchorEl);

  const handleOpenMenu = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <HeaderBar
        menuOpen={open}
        onOpenMenu={handleOpenMenu}
      />
      <Toolbar />
      <ServicesPopover
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
      />
    </>
  );
};

export default Header;